export class AppSegmento {
    idNmAudiencia: number;
    idNmCampaniaAudiencia: number;
    idNmCampania: number;
    descripcion: string;
  
    constructor(
      idNmAudiencia: number,
      idNmCampaniaAudiencia: number,
      idNmCampania: number,
      descripcion: string
    ) {
      this.idNmAudiencia = idNmAudiencia;
      this.idNmCampaniaAudiencia = idNmCampaniaAudiencia;
      this.idNmCampania = idNmCampania;
      this.descripcion = descripcion;
    }
  }